export default __webpack_public_path__ + "static/home-mobile-61c34347ad0c6032d8d78b6e54f855e6.png";